import { createBrowserHistory } from "history";

// https://skryvets.com/blog/2018/09/20/an-elegant-solution-of-deploying-react-app-into-a-subdirectory/
export default createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});
